<template>
  <div class="gl-bar-equalizer">
    <div
      v-for="(bar, index) in totalBars"
      :key="index"
      class="bar"
      :class="barClasses(index)"
      :style="getBarStyle(index)"
      @animationend="handleAnimationEnd(index)"
    />
  </div>
</template>

<script>
// utils
import { getColorByRiskLevel } from '@/utils/risk-formatter'

export default {
  name: 'GlBarEqualizer',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Number, String],
      default: null,
    },
    totalBars: {
      type: Number,
      default: 40,
    },
  },
  data() {
    return {
      coloredBars: [],
    }
  },
  computed: {
    numberValue() {
      if (this.value == null) {
        return null
      }
      return Number(this.value)
    },
    hasValue() {
      return (
        typeof this.numberValue === 'number' &&
        this.numberValue >= 0 &&
        this.numberValue <= 100
      )
    },
    filledBars() {
      return this.hasValue
        ? Math.max(1, Math.round((this.numberValue / 100) * this.totalBars))
        : 0
    },
    fillColor() {
      return this.hasValue
        ? this.getColorByRiskLevel(this.numberValue)
        : null
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.coloredBars = []
      },
    },
  },
  methods: {
    getColorByRiskLevel,
    barClasses(index) {
      if (this.loading) {
        return ['loading-bar']
      }

      return {
        'animate-fill':
          index < this.filledBars && !this.coloredBars.includes(index),
        colored: this.coloredBars.includes(index),
      }
    },
    getBarStyle(index) {
      const delay = `${index * 30}ms`

      if (this.loading) {
        return {
          animationDelay: delay,
          animationDuration: '1s',
        }
      }

      return {
        animationDelay: delay,
        backgroundColor:
          this.coloredBars.includes(index) && this.fillColor
            ? this.fillColor
            : 'rgba(9, 21, 64, 0.08)',
      }
    },
    handleAnimationEnd(index) {
      if (!this.loading && !this.coloredBars.includes(index)) {
        this.coloredBars.push(index)
      }
    },
  },
}
</script>

<style scoped>
.gl-bar-equalizer {
  width: 100%;
  display: flex;
  gap: 2px;
  height: 24px;
}

.bar {
  flex: 1;
  border-radius: 2px;
  background-color: var(--Basic-200, rgba(9, 21, 64, 0.08));
  transition: background-color 0.3s ease;
}
.bar:hover {
  transform: scaleY(1.2);
}

.animate-fill {
  animation: fillIn 0.3s ease forwards;
}

.loading-bar {
  animation: loadingPulse 1s ease-in-out infinite;
}

@keyframes fillIn {
  0% {
    transform: scale(0.8);
    opacity: 0.8;
  }
  50% {
    transform: scaleY(1.2);
    opacity: 0.9;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes loadingPulse {
  0%,
  100% {
    transform: scaleY(0.9);
    opacity: 0.8;
  }
  50% {
    transform: scaleY(1.1);
    opacity: 1;
  }
}
</style>
